/** @jsx jsx */
import React from 'react';
import '../Home.css';
import { jsx } from '@emotion/core';
import FullScreenImage from 'orbiter-web-components/src/components/fullScreenImage/FullScreenImage';
import { Container, Row, Col } from 'react-bootstrap';
import { contentContainerStyling, containerStyling, ColStyling, contentStyling, contentLogoStyling } from '../homeCSS';
import TopCard from 'orbiter-web-components/src/components/card/TopCard';
export default class Startpagina extends React.Component {
    // public static async loadServerData(props: any): Promise<any> {
    //     const db = await connectToDatabase();
    //     const theDB = db.getDb();
    //     // console.log(theDB);
    //     const collection = db.getCollection('section');
    //     // console.log(collection);
    //     const postcode = collection.find({strid: 'postcode'});
    //     // console.log('postcode:', postcode);
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //             resolve({
    //                 test: 'to SSR!',
    //                 postcode,
    //             });
    //         }, 500);
    //     });
    // }
    constructor(a) {
        super(a);
    }
    render() {
        return (jsx(FullScreenImage, { onClick: this.props.onClick, contentContainerStyle: contentContainerStyling, backgroundImage: "/images/backgrounds/home.jpg", nextPageImage: "/images/arrowButtons/arrowBottom.svg" },
            jsx(Container, { css: containerStyling },
                jsx(Row, null,
                    jsx(Col, { md: 12, css: ColStyling },
                        jsx(TopCard, { imageSrc: "/images/logos/white@3x.png", cardStyle: contentStyling, imageStyle: contentLogoStyling }))))));
    }
}
//# sourceMappingURL=Startpagina.js.map